<template>
  <div class="relative h-screen bg-background font-sans text-text overflow-hidden">
    <!-- Fixed Header -->
    <header class="fixed top-0 left-0 right-0 z-30">
      <Header />
    </header>
    
    <!-- Main Content (scrollable, full width except margins) -->
    <main
      class="absolute overflow-auto"
      :style="mainStyle"
    >
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Header from './Header.vue';

const mainStyle = computed(() => ({
  top: '5rem',
  bottom: '1rem',
  left: '1rem',
  right: '1rem',
  paddingBottom: '0.1rem',
}));
</script>

<style scoped>
/* Layout uses fixed positioning with Tailwind classes */
</style>
